import { z } from 'zod';

import { EFFECT_ATOMS, REWARD_ATOMS } from '../atom-ids';

export { EFFECT_ATOMS, REWARD_ATOMS } from '../atom-ids';

export const effectAtomSchema = z.enum(EFFECT_ATOMS);
export type EffectAtom = z.infer<typeof effectAtomSchema>;

/**
 * Intentional alias of `effectAtomSchema` for entity payloads (e.g. move `effects[].atom`).
 * Keeps a separate export name so per-atom `params` narrowing in Phase 0.5b can diverge
 * without renaming call sites that only care about the atom id string.
 */
export const effectAtomIdSchema = effectAtomSchema;
export type EffectAtomId = z.infer<typeof effectAtomIdSchema>;

export const rewardAtomSchema = z.enum(REWARD_ATOMS);
export type RewardAtom = z.infer<typeof rewardAtomSchema>;
